export default "__VITE_ASSET__GOFNxQi9__"